import * as Yup from 'yup';

export const summarySchema = Yup.object().shape({
	optOut: Yup.boolean(),
	SendDocumentsByPost: Yup.boolean(),
	confirm: Yup.boolean().oneOf([true], 'You must confirm the details are correct'),
	voluntaryExcess: Yup.string().required('Voluntary excess is required'),
	levelOfCover: Yup.string().required('Level of cover is required'),
});
